//------------------------------------------------------------------------
// Sticky desktop nav that hides on scroll
//
// NOTE: We can’t import the Protocol JS since it doesn’t use ES modules:
//       import '@mozilla-protocol/core/protocol/js/protocol-supports';
//       import '@mozilla-protocol/core/protocol/js/protocol-navigation';
//------------------------------------------------------------------------
import Navigation from '../lib/protocol-navigation';

const header = document.querySelector('#header');
if (header) {
  const headerSticky = new Navigation(header);
}
